import * as React from 'react';
import cx from 'classnames';

import { Switch, Route, useRouteMatch } from 'react-router-dom';

import { lazyLoadComponent } from '@frontend/app/utils/lazyLoadComponent';
import styles from './OrganizationsView.scss';

const { lazy } = React;
const OrganizationListView = lazy(() => import('./OrganizationListView'));
const OrganizationDetailView = lazy(() => import('./OrganizationDetailView'));

interface IProps {
  className?: string;
}

/**
 * @type {React.FunctionComponent}
 */
const OrganizationsView: React.FunctionComponent<React.PropsWithChildren<IProps>> = React.memo((props) => {
  const match = useRouteMatch();

  return (
    <div className={cx(styles.OrganizationsView, props.className)}>
      <Switch>
        <Route path={`${match.path}`} exact render={lazyLoadComponent(OrganizationListView)} />
        <Route path={`${match.path}/:organizationId`} render={lazyLoadComponent(OrganizationDetailView)} />
      </Switch>
    </div>
  );
});

export default OrganizationsView;
